import { render, staticRenderFns } from "./TableCellOrderItemsVariationId.vue?vue&type=template&id=746bee4d&scoped=true"
import script from "./TableCellOrderItemsVariationId.vue?vue&type=script&lang=js"
export * from "./TableCellOrderItemsVariationId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746bee4d",
  null
  
)

export default component.exports